import { COLOR } from 'admin/constants/styles';
import React from 'react';
import styled from 'styled-components';

type Button = {
  text: string;
  value: string;
  is_active?: boolean;
  isActive?: boolean;
};

type Props = {
  buttons: Button[];
  onClick?: (target: EventTarget, index: number) => void;
  className?: string;
  disabled?: boolean;
  activeIndex?: number;
  gap?: number;
};

const Wrapper = styled.div`
  a:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  a:last-child {
    border-radius: 0px 6px 6px 0px;
  }
`;

const Button = styled.a<{
  isActive?: boolean;
  gap?: number;
}>`
  display: inline-block;
  cursor: pointer;
  background: ${(props) => (props.isActive ? COLOR.corporatePrimaryColor : COLOR.lightGray)};
  color: ${(props) => (props.isActive ? 'white' : COLOR.gray)} !important;
  padding: 5px 10px;
  min-width: 100px;
  text-align: center;
  ${(props) => (props.gap ? `margin-right: ${props.gap}px;` : '')}
`;

/**
 * [is_active] is deprecated. Use [isActive] instead.
 */
const ButtonGroup = ({
  buttons,
  onClick,
  className = '',
  disabled = false,
  activeIndex,
  gap = 0,
}: Props) => {
  return (
    <Wrapper className={className}>
      {buttons.map((b, i) => (
        <Button
          key={b.text}
          data-index={i}
          isActive={b.isActive ?? b.is_active ?? activeIndex === i}
          onClick={(e) => !disabled && onClick?.(e.target, i)}
          data-value={b.value}
          gap={gap}
        >
          {b.text}
        </Button>
      ))}
    </Wrapper>
  );
};

export default styled(ButtonGroup)``;
